import React, { useEffect, useState, useRef, use } from "react";
import axios from "axios";
import {
  Container, Row, Col, Card, Form, Alert, Spinner, Table, Modal
} from "react-bootstrap";
import LineMonthSeries from "./LineMontSeries";

export default function ReportesContables() {
  // const [year, setYear] = useState(new Date().getFullYear());
  // const [summary, setSummary] = useState(null);
  // const [monthly, setMonthly] = useState([]);
  // const [morosos, setMorosos] = useState([]);
  // const [alert, setAlert] = useState(null);
  // const [loading, setLoading] = useState(false);
  // const [showMorosos, setShowMorosos] = useState(false);

  // const nameCache = useRef({ tipos: {} });

  // const formatMoney = (n) =>
  //   new Intl.NumberFormat("es-CL", {
  //     style: "currency",
  //     currency: "CLP",
  //     minimumFractionDigits: 0,
  //   }).format(n || 0);

  // const fetchPagos = () => {
  //   try {
  //     const pagosMensuales = axios.get(`https://socios.kolpingchile.cl/backend/api/pagos`);
  //     const pagosEspeciales = axios.get(`https://socios.kolpingchile.cl/backend/api/cuotas_especiales`);
  //     return Promise.all([pagosMensuales, pagosEspeciales]).then(([mensualesRes, especialesRes]) => {
  //       return {
  //         mensuales: mensualesRes.data || [],
  //         especiales: especialesRes.data || [],
  //       };
  //     });
  //   } catch (error) {
  //     console.error("Error al obtener pagos:", error);
  //     return [];
  //   }
  // };
  // useEffect(() => {
  //   fetchPagos().then((data) => {
  //     console.log("Pagos mensuales:", data.mensuales);
  //     console.log("Pagos especiales:", data.especiales);
  //   }
  //   );
  // }, []);

  // const fetchNameById = async (endpoint, id) => {
  //   if (!id) return "Desconocido";
  //   if (nameCache.current[endpoint]?.[id]) return nameCache.current[endpoint][id];
  //   try {
  //     const { data } = await axios.get(`https://socios.kolpingchile.cl/backend/api/${endpoint}/${id}`);
  //     const name = data.nombre || "Desconocido";
  //     nameCache.current[endpoint] ??= {};
  //     nameCache.current[endpoint][id] = name;
  //     return name;
  //   } catch (error) {
  //     console.error(`Error al obtener ${endpoint} con ID ${id}:`, error);
  //     return "Desconocido";
  //   }
  // };

  // const getUltimoMesPagado = (pagos = []) => {
  //   if (!pagos.length) return "N/A";
  //   const sorted = [...pagos].sort((a, b) => a.año - b.año || a.mes - b.mes);
  //   const last = sorted[sorted.length - 1];
  //   return `${last.mes} ${last.año}`;
  // };

  // useEffect(() => {
  //   async function fetchAll() {
  //     setLoading(true);
  //     try {
  //       const now = new Date();
  //       const currentMonth = now.getMonth() + 1;
  //       const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
  //       const comparisonYear = currentMonth === 1 ? now.getFullYear() - 1 : now.getFullYear();

  //       const [summaryRes, monthlyRes, morososRes, comparisonRes] = await Promise.all([
  //         axios.get(`https://socios.kolpingchile.cl/backend/api/reportes/${year}`),
  //         axios.get(`https://socios.kolpingchile.cl/backend/api/reportes/monthly/${year}`),
  //         axios.get(`https://socios.kolpingchile.cl/backend/api/reportes/morosos/${now.getFullYear()}/${currentMonth}`),
  //         axios.get(`https://socios.kolpingchile.cl/backend/api/reportes/compare-months/${comparisonYear}/${previousMonth}/${currentMonth}`),
  //       ]);

  //       setSummary(summaryRes.data);
  //       setMonthly(monthlyRes.data.months || []);
  //       interpret(comparisonRes.data.rows);

  //       const morososData = morososRes.data.morosos || [];
  //       const morososWithTipo = await Promise.all(
  //         morososData.map(async (m) => ({
  //           ...m,
  //           tipo_socio_nombre: await fetchNameById("tipos", m.tipo_socio),
  //           ultimo_pago: getUltimoMesPagado(m.pagos),
  //         }))
  //       );
  //       setMorosos(morososWithTipo);
  //     } catch (err) {
  //       console.error("Error cargando reportes:", err);
  //       setAlert("⚠️ No se pudieron cargar los datos. Intenta nuevamente.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   }

  //   fetchAll();
  // }, [year]);

  // function interpret(data) {
  //   if (!data || data.length < 2) return;
  //   const curr = parseFloat(data.find((d) => d.periodo === "current")?.total || 0);
  //   const prev = parseFloat(data.find((d) => d.periodo === "previous")?.total || 0);
  //   if (prev > 0) {
  //     const change = ((curr - prev) / prev) * 100;
  //     if (change < -5)
  //       setAlert(`⚠️ La recaudación de este mes (${formatMoney(curr)}) cayó ${change.toFixed(1)}% respecto al mes anterior (${formatMoney(prev)}).`);
  //     else if (change > 5)
  //       setAlert(`✅ La recaudación de este mes (${formatMoney(curr)}) creció ${change.toFixed(1)}% respecto al mes anterior (${formatMoney(prev)}).`);
  //     else
  //       setAlert(`ℹ️ La recaudación de este mes (${formatMoney(curr)}) se mantuvo estable respecto al mes anterior (${formatMoney(prev)}).`);
  //   }
  // }

  // const handleShowMorosos = () => setShowMorosos(true);
  // const handleCloseMorosos = () => setShowMorosos(false);

  return (
    <Container fluid className="py-4">
      {/* <Row className="mb-3">
        <Col md={3}>
          <Form.Group>
            <Form.Label>Año</Form.Label>
            <Form.Select value={year} onChange={(e) => setYear(parseInt(e.target.value))}>
              {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      {alert && (
        <Alert variant={alert.includes("⚠️") ? "warning" : alert.includes("✅") ? "success" : "info"}>
          {alert}
        </Alert>
      )}

      {loading ? (
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Cargando reportes contables...</p>
        </div>
      ) : (
        <>
          <Row>
            <Col md={4}>
              <Card>
                <Card.Body>
                  <Card.Title>Resumen general {year}</Card.Title>
                  {summary ? (
                    <>
                      <p><strong>Pagos:</strong> {summary.total_monto?.[0]?.pagos_count || 0}</p>
                      <p><strong>Total recaudado:</strong> {formatMoney(summary.total_monto?.[0]?.total_recaudado || 0)}</p>
                      <p><strong>Cuotas especiales:</strong></p>
                      <ul>
                        {summary.cuotasEspeciales?.length
                          ? summary.cuotasEspeciales.map((c, i) => (
                              <li key={i}>{c.tipo}: {c.pagadas} pagadas / {c.pendientes} pendientes</li>
                            ))
                          : <li>Sin información disponible</li>}
                      </ul>
                    </>
                  ) : <p>No hay datos disponibles</p>}
                </Card.Body>
              </Card>
            </Col>

            <Col md={8}>
              <Card>
                <Card.Body>
                  <Card.Title>Serie mensual</Card.Title>
                  {monthly.length > 0
                    ? <LineMonthSeries data={monthly} year={year} />
                    : <p className="text-muted">No hay datos mensuales aún.</p>}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col md={8}>
              <Card>
                <Card.Body>
                  <Card.Title>Morosos</Card.Title>
                  <p>Total de morosos actuales: {morosos.length}</p>
                  <button className="btn btn-primary" onClick={handleShowMorosos}>Ver lista de morosos</button>
                  
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Modal show={showMorosos} onHide={handleCloseMorosos}>
            <Modal.Header closeButton>
              <Modal.Title>Morosos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {morosos.length > 0 ? (
                    <Table striped bordered hover size="sm" responsive>
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>RUT</th>
                          <th>Tipo de socio</th>
                          <th>Último pago</th>
                        </tr>
                      </thead>
                      <tbody>
                        {morosos.map((m) => (
                          <tr key={m.n_socio}>
                            <td>{m.nombre} {m.apellido}</td>
                            <td>{m.rut}</td>
                            <td>{m.tipo_socio_nombre}</td>
                            <td>{m.ultimo_pago || "N/A"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="text-center text-muted py-3">No hay morosos registrados.</div>
                  )}
                </Modal.Body>
          </Modal>
        </>
      )} */}
      En Desarrollo...
    </Container>
  );
}
